// extracted by mini-css-extract-plugin
export default {"pages_filter":"pages-filter_pages_filter__Cimt1","filter_elem_wrapper":"pages-filter_filter_elem_wrapper__o2fX8"};